// Baylor University's undergraduate majors (#2746). Read on 2026-10-01 from
// Baylor Admissions' official Majors and Minors page, which files each
// program under its school with its degrees. Baylor's site and catalog
// (catalog.baylor.edu) refused scripted reads on the day (a bot check), so
// the page was read through a fetch tool. Kept: every entry with a
// bachelor's degree. Left out: entries with no degree (minors such as
// Arabic or Forensic Science, pre-professional tracks such as Pre-Medicine,
// and education certifications other than Physical Education, which leads to
// a BSED). Economics is listed under Arts and Sciences (BA, BS) and Business
// (BBA); Computer Science (BA, BSCS) sits here under Engineering and Computer
// Science only, and Music (BA) under the School of Music only. School names
// are Baylor's full names.
const majors = {
    "slug": "baylor-university",
    "read": "2026-10-01",
    "intro": "Every major with a bachelor's degree on Baylor Admissions' official Majors and Minors list, grouped by the school that offers it, with the degrees it leads to. Minors, pre-professional tracks and certificates are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Baylor Admissions, Majors and Minors",
                "url": "https://admissions.web.baylor.edu/about-baylor/majors-minors"
            },
            "majors": [
                {
                    "name": "Advertising & Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Arabic & Middle East Studies",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BA, BS"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA, BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA, BS"
                },
                {
                    "name": "Chinese Language & Culture",
                    "degree": "BA"
                },
                {
                    "name": "Christianity and Arts",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Earth Science",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA, BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Health Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Film & Digital Media",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geosciences",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Greek",
                    "degree": "BA"
                },
                {
                    "name": "Greek & Roman Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Latin",
                    "degree": "BA"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Medical Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Middle East Studies",
                    "degree": "BA"
                },
                {
                    "name": "Multimedia Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Museum Studies",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Professional Writing & Rhetoric",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Religion",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Science Research Fellows",
                    "degree": "BS"
                },
                {
                    "name": "Slavic & East European Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Sports Media",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA, BFA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Design & Technology",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre Performance",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "Hankamer School of Business",
            "source": {
                "label": "Baylor Admissions, Majors and Minors",
                "url": "https://admissions.web.baylor.edu/about-baylor/majors-minors"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business Fellows",
                    "degree": "BBA"
                },
                {
                    "name": "Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Entrepreneurship & Corporate Innovation",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BBA"
                },
                {
                    "name": "International Business",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Professional Selling",
                    "degree": "BBA"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "School of Engineering and Computer Science",
            "source": {
                "label": "Baylor Admissions, Majors and Minors",
                "url": "https://admissions.web.baylor.edu/about-baylor/majors-minors"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BSAE"
                },
                {
                    "name": "Aviation Sciences",
                    "degree": "BSA"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BSBME"
                },
                {
                    "name": "Bioinformatics",
                    "degree": "BSI"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA, BSCS"
                },
                {
                    "name": "Computer Science Fellows",
                    "degree": "BSC"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BSI"
                },
                {
                    "name": "Data Science",
                    "degree": "BSI"
                },
                {
                    "name": "Electrical & Computer Engineering",
                    "degree": "BSECE"
                },
                {
                    "name": "Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                }
            ]
        },
        {
            "name": "Robbins College of Health and Human Sciences",
            "source": {
                "label": "Baylor Admissions, Majors and Minors",
                "url": "https://admissions.web.baylor.edu/about-baylor/majors-minors"
            },
            "majors": [
                {
                    "name": "Apparel Studies",
                    "degree": "BS"
                },
                {
                    "name": "Child & Family Studies",
                    "degree": "BS"
                },
                {
                    "name": "Communication Sciences & Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Education Certification - Physical Education",
                    "degree": "BSED"
                },
                {
                    "name": "Exercise Physiology",
                    "degree": "BS"
                },
                {
                    "name": "Family & Consumer Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Health Science Studies",
                    "degree": "BS"
                },
                {
                    "name": "Health, Kinesiology, and Leisure Studies",
                    "degree": "BSED"
                },
                {
                    "name": "Interior Design",
                    "degree": "BS"
                },
                {
                    "name": "Intrauniversity Dance",
                    "degree": "BA"
                },
                {
                    "name": "Nutrition Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BSPH"
                },
                {
                    "name": "Recreation & Leisure Services",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Music",
            "source": {
                "label": "Baylor Admissions, Majors and Minors",
                "url": "https://admissions.web.baylor.edu/about-baylor/majors-minors"
            },
            "majors": [
                {
                    "name": "Choral Music",
                    "degree": "BME"
                },
                {
                    "name": "Church Music",
                    "degree": "BA, BM"
                },
                {
                    "name": "Composition",
                    "degree": "BM"
                },
                {
                    "name": "Instrumental Music",
                    "degree": "BME"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Education",
                    "degree": "BME"
                },
                {
                    "name": "Music History & Literature",
                    "degree": "BM"
                },
                {
                    "name": "Pedagogy",
                    "degree": "BM"
                },
                {
                    "name": "Performance",
                    "degree": "BM"
                },
                {
                    "name": "Theory",
                    "degree": "BM"
                }
            ]
        },
        {
            "name": "Louise Herrington School of Nursing",
            "source": {
                "label": "Baylor Admissions, Majors and Minors",
                "url": "https://admissions.web.baylor.edu/about-baylor/majors-minors"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "Diana R. Garland School of Social Work",
            "source": {
                "label": "Baylor Admissions, Majors and Minors",
                "url": "https://admissions.web.baylor.edu/about-baylor/majors-minors"
            },
            "majors": [
                {
                    "name": "Nonprofit Leadership",
                    "degree": "BA"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        },
        {
            "name": "Honors College",
            "source": {
                "label": "Baylor Admissions, Majors and Minors",
                "url": "https://admissions.web.baylor.edu/about-baylor/majors-minors"
            },
            "majors": [
                {
                    "name": "Ethics",
                    "degree": "BA"
                },
                {
                    "name": "Great Texts of the Western Tradition",
                    "degree": "BA"
                },
                {
                    "name": "University Scholars",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Baylor Admissions, Majors and Minors",
                "url": "https://admissions.web.baylor.edu/about-baylor/majors-minors"
            },
            "majors": [
                {
                    "name": "Education - Elementary Education",
                    "degree": "BSED"
                },
                {
                    "name": "Education - Secondary English, Language Arts, and Reading",
                    "degree": "BSED"
                },
                {
                    "name": "Education - Secondary Mathematics",
                    "degree": "BSED"
                },
                {
                    "name": "Education - Secondary Science",
                    "degree": "BSED"
                },
                {
                    "name": "Education - Secondary Social Studies",
                    "degree": "BSED"
                },
                {
                    "name": "Education - Special Education",
                    "degree": "BSED"
                },
                {
                    "name": "Educational Studies",
                    "degree": "BSED"
                }
            ]
        }
    ]
};

export default majors;
